import styled, { css } from 'styled-components';
import { Flex, Box, palette, radius } from '@landr/maestro';
import { ColumnRatio, ColumnDirection } from './types';

const infoRatio = {
    half: css`
        flex-basis: 50%;
    `,
    third: css`
        flex-basis: 37.666%;
    `,
    full: css`
        flex-basis: 100%;
    `,
};

const mediaRatio = {
    half: css`
        flex-basis: 50%;
    `,
    third: css`
        flex-basis: 62.333%;
    `,
    full: css`
        flex-basis: 100%;
    `,
};

const styles = {
    infoRatio: infoRatio,
    mediaRatio: mediaRatio,
};

export const Container = styled(Flex)`
    overflow: hidden;
    width: 100%;
    display: relative;
    border-radius: ${radius('base')};
`;

export const Info = styled(Flex)<{
    columnRatio: ColumnRatio;
    direction: ColumnDirection;
    isColored: boolean;
}>`
    ${({ columnRatio }) => styles.infoRatio[columnRatio]};

    align-content: center;
    justify-content: center;

    ${({ isColored }) =>
        isColored &&
        css`
            background-color: ${palette('neutral.900')};
        `};
`;

export const Media = styled(Box)<{
    columnRatio: ColumnRatio;
    isColored: boolean;
}>`
    overflow: hidden;
    position: relative;
    ${({ columnRatio }) => styles.mediaRatio[columnRatio]};

    ${({ isColored }) =>
        isColored &&
        css`
            border-radius: ${radius('lg')};
            background-color: ${palette('neutral.900', 0.48)};
        `};
`;
